export default {
  brandManagement: {
    menu: {
      localMenu: {
        publishButton: 'Publier',
        publishSuccess: 'Menu publié avec succès.',
        menu: {
          createMenuButton: 'Créer un menu',
          reorderSuccess: 'Ordre des menus mis à jour avec succès',
          list: {
            noData: 'Rien ici pour le moment',
            noDataInfo: "Il n'y a pas de menus",
            categories: 'Catégories : {total}',
            menuSize: {
              warnTooltip:
                'Menu proche de la limite de taille\n{size} est proche de la limite de 6 Mo. Supprimez les éléments ou modificateurs inactifs pour vous assurer que le menu se synchronise',
              dangerTooltip:
                "Réduire la taille du menu\nIl dépasse la limite de 6 Mo et ne se synchronisera pas. Supprimez les éléments ou modificateurs inactifs pour libérer de l'espace.",
            },
          },
          sidebar: {
            createTitle: 'Créer un nouveau menu',
            duplicateTitle: 'Dupliquer {menu}',
            updateMenuTitle: 'Mettre à jour {menu}',
            menuActionLabel: 'Plus',
            name: 'Nom du menu',
            namePlaceholder: 'Saisir un nom',
            image: 'Image de la menu',
            primaryAction: 'Enregistrer',
            secondaryAction: 'Annuler',
            copiedSuccess: 'Identifiant de catégorie copié',
            duplicate: 'Dupliquer',
            duplicateInfo: `Les menus dupliqués partagent les mêmes éléments que l'original. Modifier les informations d'un élément dans la copie met également à jour l'original.`,
            createSuccess: 'Menu créé avec succès',
            updateSuccess: 'Menu mis à jour avec succès',
            deleteSuccess: 'Menu supprimé avec succès',
            delete: {
              menuTabLabel: 'Supprimer',
              dialog: {
                header: 'Confirmation de suppression',
                message:
                  'Êtes-vous sûr de vouloir supprimer {RecordName} ?\n Cette action ne peut pas être annulée.',
                acceptLabel: 'Oui, supprimer',
                rejectLabel: 'Non, annuler',
              },
            },
            subHeaders: {
              altLanguagesSettings: 'Langues alternatives',
            },
            altLanguages: {
              nameLabel: 'Nom du menu',
              namePlaceholder: 'Saisir un nom',
            },
          },
          editCategory: 'Modifier la catégorie',
          category: {
            createCategoryButton: 'Créer une catégorie',
            createItemButton: 'Créer un élément',
            activeSwitchValue: 'Actif',
            inactiveSwitchValue: 'Inactif',
            reorderSuccess: 'Ordre des catégories mis à jour avec succès',
            list: {
              noData: 'Rien ici pour le moment',
              noDataInfo: "Il n'y a pas de catégories",
            },
            sidebar: {
              createTitle: 'Créer une nouvelle catégorie',
              duplicateTitle: 'Dupliquer {category}',
              updateTitle: 'Mettre à jour {category}',
              menuActionLabel: 'Plus',
              name: 'Nom de la catégorie',
              namePlaceholder: 'Saisir un nom',
              image: 'Image de la catégorie',
              label: "Nom dans l'application",
              labelPlaceholder: 'Ajouter nouveau ou utiliser le nom par défaut de la catégorie',
              status: 'Statut',
              items: 'Éléments attachés à cette catégorie',
              itemsPlaceholder: 'Rechercher des éléments pour cette catégorie',
              primaryAction: 'Enregistrer',
              secondaryAction: 'Annuler',
              duplicate: 'Dupliquer',
              duplicateInfo: `Les catégories dupliquées partagent les mêmes éléments que l'original. Modifier les informations d'un élément dans la copie met également à jour l'original.`,
              createSuccess: 'Catégorie créée avec succès',
              updateSuccess: 'Catégorie mise à jour avec succès',
              deleteSuccess: 'Catégorie supprimée avec succès',
              delete: {
                menuTabLabel: 'Supprimer',
                dialog: {
                  header: 'Confirmation de suppression',
                  message:
                    'Êtes-vous sûr de vouloir supprimer {RecordName} ?\n Cette action ne peut pas être annulée.',
                  acceptLabel: 'Oui, supprimer',
                  rejectLabel: 'Non, annuler',
                },
              },
              subHeaders: {
                altLanguagesSettings: 'Langues alternatives',
              },
              altLanguages: {
                nameLabel: 'Nom de la catégorie',
                namePlaceholder: 'Saisir un nom',
              },
            },
            arrangeItem: 'Organiser les éléments',
            addItem: 'Ajouter un élément',
            attachItem: 'Attacher un élément',
            itemTable: {
              loadingItemsProgress:
                'Cette catégorie contient actuellement plus de 500 éléments, les éléments restants étant chargés en arrière-plan.',
              noItemsLine1: "Cette catégorie n'a pas d'éléments",
              noItemsLine2: 'Veuillez en ajouter pour utiliser cette catégorie',
              displayingTotal: '{displayedItemsTotal} sur {totalItems} éléments',
            },
            addItemSidebar: {
              createItem: 'Créer',
              title: 'Ajouter un élément',
              primaryAction: 'Ajouter',
              menuActionLabel: 'Plus',
              secondaryAction: 'Annuler',
              info: 'Sélectionnez les éléments à ajouter à cette catégorie de menu.',
              searchLabel: 'Rechercher des éléments à ajouter',
              searchPlaceholder: "Rechercher par nom d'élément",
              selectedModifiers: 'Éléments sélectionnés',
              posid: 'POSID : ',
              recentResults: 'Éléments récemment ajoutés',
              results: 'Résultats : {number}',
              noResultsInfo: "Nous n'avons trouvé aucun élément contenant cette requête",
              selectState: 'Sélectionner',
              unselectState: 'Désélectionner',
              updateSuccess: 'Catégorie mise à jour avec succès',
              clearFilter: 'Effacer la recherche',
              noData: 'Rien ici pour le moment',
              noItems: 'Aucun élément disponible à ajouter',
              noResults: 'Rien trouvé',
              allItemsTab: 'Tous les éléments',
              scannedItemsTab: 'Éléments scannés',
            },
          },
        },
        modifiers: {
          createModifierButton: 'Créer un modificateur',
          containerWeightTooltip:
            "Le poids du contenant est le poids du contenant fourni avec l'élément alimentaire. Aussi connu sous le nom de poids de tare.",
          noModifiers: "Aucun groupe de modificateurs n'est attaché à ce modificateur",
          globalIndicatorTooltip: "Cette relation est héritée d'un parent global",
          globalIndicatorAriaLabel: 'Indicateur de parent global pour {entity}',
          globalIndicatorAriaDescription:
            "Cette relation est héritée d'un parent global pour {entity}",
          removeAttachmentTooltip: 'Cela supprimera le modificateur de ce groupe de modificateurs',
          editGroup: 'Modifier le groupe',
          noModifiersToGroup: 'Aucun modificateur attaché à ce groupe',
          bulkSidebar: {
            updateModifierTitle: '({number}) Mise à jour en lot du modificateur',
            reset: 'Réinitialiser',
            back: 'Retour',
            multipleValues: '(Valeurs multiples)',
            multiple: '(Multiple)',
            bulkReviewInfo:
              'Vous êtes sur le point de mettre à jour les valeurs de ces champs. Veuillez examiner et confirmer que ce sont les modifications que vous souhaitez apporter :',
            bulkDeleteReviewInfo:
              'Vous êtes sur le point de supprimer ces modificateurs. Veuillez examiner et confirmer que ce sont les modifications que vous souhaitez apporter :',
            modifiers: 'Modificateurs :',
            modifiersConfirmation: 'Ces modifications influenceront :',
            modifiersToDeleteConfirmation: 'Cette action supprimera :',
            bulkConfirmationText: 'Êtes-vous sûr de vouloir appliquer vos modifications ?',
            bulkDeleteText: 'Êtes-vous sûr de vouloir supprimer ces modificateurs ?',
            bulkDeleteSuccess: 'Modificateurs supprimés avec succès',
            checkboxConfirmation:
              'Je comprends que ces modifications ne peuvent pas être annulées.',
            accept: 'Oui, appliquer',
            cancel: 'Non, annuler',
            noModifiersModified: "Il n'y a pas de modifications aux modificateurs sélectionnés.",
            alertNoModifiersAccept: 'Ok',
            updateSuccess: '{number} modificateurs mis à jour avec succès',
            saveChanges: 'Enregistrer les modifications ?',
            noModifiers:
              'Les modificateurs sélectionnés ({total}) ne partagent aucun groupe de modificateurs identique. Attachez un groupe à eux.',
          },
          modifierSidebar: {
            fullView: 'Vue complète',
            duplicateMenuLabel: 'Dupliquer',
            updateModifierNameTitle: 'Mettre à jour {modifier}',
            primaryAction: 'Enregistrer',
            secondaryAction: 'Annuler',
            menuActionLabel: 'Plus',
            modifierName: 'Nom du modificateur',
            modifierNamePlaceholder: 'Saisir un nom',
            label: "Nom dans l'application",
            labelPlaceholder: 'Ajouter nouveau ou utiliser le nom par défaut du modificateur',
            calories: 'Calories',
            caloriesPlaceholder: 'Ajouter des calories',
            containerWeight: 'Poids du contenant',
            weightAmount: 'Quantité de poids',
            weightAmountPlaceholder: 'Ajouter une valeur',
            weightUnit: 'Unité de poids',
            weightUnitPlaceholder: 'Sélectionner une unité',
            priority: 'Séquence dans KDS',
            priorityPlaceholder: 'Ajouter une séquence pour KDS',
            posid: 'POSID',
            posidPlaceholder: 'Le POSID sera auto-généré',
            inStock: 'En stock',
            description: 'Description',
            descriptionPlaceholder: 'Ajouter une description',
            status: 'Statut',
            active: 'Actif',
            inactive: 'Inactif',
            taxTags: 'Étiquettes fiscales',
            taxTagsPlaceholder: 'Aucune pour le moment',
            groups: 'Modificateurs attachés',
            modifierGroups: 'Groupes de modificateurs attachés',
            groupsPlaceholder: 'Rechercher des groupes pour ce modificateur',
            reportingCategory: 'Catégorie de rapport',
            reportingCategoryPlaceholder: 'Sélectionner une catégorie',
            reportingSubCategory: 'Sous-catégorie de rapport',
            reportingSubCategoryPlaceholder: 'Rechercher ou taper une sous-catégorie',
            reportingSubCategoryNoResults:
              'Aucun résultat pour ce critère. Cela créera une nouvelle sous-catégorie de rapport.',
            createSuccess: 'Modificateur créé avec succès',
            updateSuccess: 'Modificateur mis à jour avec succès',
            deleteSuccess: 'Modificateur supprimé avec succès',
            image: 'Image du modificateur',
            modifierGroupSearch: 'Trouver des groupes de modificateurs à attacher',
            modifierGroupsPlaceholder:
              'Rechercher des groupes de modificateurs pour ce modificateur',
            kitchenRoute: 'Route de cuisine',
            kitchenRoutePlaceholder: 'Sélectionner ou créer une route de cuisine',
            priceManagement: {
              title: 'Gestion des prix',
              price: 'Prix',
              basePrice: 'Prix de base',
              pricePlaceholder: '$Mettre un prix',
              priceTooltip:
                'Le prix de base est le prix de départ pour cet élément. Les niveaux de prix sont ajoutés par-dessus.',
              priceCaptionPriceLevels:
                'Cet élément a {quantity} niveau de prix. Sélectionnez {fullView} pour le modifier. | Cet élément a {quantity} niveaux de prix. Sélectionnez {fullView} pour les modifier.',
              priceCaptionNoPriceLevels:
                "Cet élément n'a pas de niveaux de prix. Créez des niveaux de prix lorsque vous modifiez un groupe de menu",
              priceCaptionFullView: 'Vue complète',
            },
            tabLabels: {
              general: 'Général',
              modifiersGroups: 'Groupes de modificateurs',
              menuWorks: 'Menuworks',
              selectedModifiers: 'Modificateurs sélectionnés',
            },
            delete: {
              menuTabLabel: 'Supprimer',
              menuTabLabelBulk: 'Tout supprimer',
              dialog: {
                header: 'Confirmation de suppression',
                message:
                  'Êtes-vous sûr de vouloir supprimer {RecordName} ?\n Cette action ne peut pas être annulée.',
                acceptLabel: 'Oui, supprimer',
                rejectLabel: 'Non, annuler',
              },
            },
            nextep: {
              preSurcharge: 'Prix Genius avant surcharge',
              postSurcharge: 'Prix Genius après surcharge',
              preSurchargeTooltip:
                "Ajouter un prix personnalisé à ce modificateur qui est appliqué jusqu'à ce que la limite de surcharge soit atteinte. Prix normal par défaut.",
              postSurchargeTooltip:
                'Ajouter un prix personnalisé à ce modificateur qui est appliqué après que la limite de surcharge soit atteinte. Prix normal par défaut.',
              priceForLess: 'Prix pour moins',
              priceForNone: 'Prix pour aucun',
              priceForSide: 'Prix pour côté',
              priceForMore: 'Prix pour plus',
              priceForExtra: 'Prix pour extra',
              selectionAlert:
                "Vous ne pouvez pas personnaliser le type de commande Genius : {orderType}. Consultez les paramètres du groupe de modificateurs pour plus d'options.",
              orderBySelection: 'Commander par sélection',
              surchargeLimit: 'Limite de surcharge',
              noSurchargeAlert:
                "{field} est désactivé. Consultez les paramètres du groupe de modificateurs pour plus d'options.",
            },
          },
          groups: {
            activeSwitchValue: 'Actif',
            inactiveSwitchValue: 'Inactif',
            duplicateModifierGroupBtn: 'Dupliquer le groupe de modificateurs',
            searchPlaceholder: 'Rechercher un groupe par nom',
            all: 'Tous les modificateurs',
            groupHeader: 'Groupes de modificateurs',
            createGroupButton: 'Créer un groupe',
            clearFilter: 'Effacer la recherche',
            noData: 'Rien ici pour le moment',
            noResults: 'Rien trouvé',
            noDataInfo: "Il n'y a pas de groupes de modificateurs",
            noResultsInfo: "Nous n'avons trouvé aucun groupe contenant cette requête",
            globalIndicatorTooltip: "Cette relation est héritée d'un parent global",
            globalIndicatorAriaLabel: 'Indicateur de parent global pour {entity}',
            globalIndicatorAriaDescription:
              "Cette relation est héritée d'un parent global pour {entity}",
            removeAttachmentTooltip: 'Cela supprimera le groupe de modificateurs de cet élément',
            groupSidebar: {
              createGroupTitle: 'Créer un nouveau groupe de modificateurs',
              duplicateModifierGroupTitle: 'Dupliquer {group}',
              duplicateModifierGroupBlurb:
                'Les modificateurs attachés dans ce groupe seront également dupliqués et assignés avec des POSIDs différents',
              duplicateModifierWhenDuplicatingModifierGroup: 'Dupliquer les modificateurs',
              duplicateModifierWhenDuplicatingModifierGroupDescription:
                'Sélectionner pour dupliquer les modificateurs avec de nouveaux POSIDs',
              updateGroupTitle: 'Mettre à jour {group}',
              primaryAction: 'Enregistrer',
              secondaryAction: 'Annuler',
              incremental: 'Incrémental',
              status: 'Statut',
              type: 'Type de groupe Genius',
              groupName: 'Nom du groupe',
              groupNamePlaceholder: 'Saisir un nom',
              label: "Nom dans l'application",
              labelPlaceholder:
                'Ajouter nouveau ou utiliser le nom par défaut du groupe de modificateurs',
              modifiersRange: "Modificateurs qu'un invité peut choisir",
              min: 'Minimum',
              minPlaceholder: 'Minimum',
              max: 'Maximum',
              maxPlaceholder: 'Maximum',
              priority: 'Séquence dans KDS',
              priorityPlaceholder: 'Ajouter une séquence pour KDS',
              items: 'Éléments attachés dans ce groupe',
              groupsItems: 'Éléments attachés',
              itemsPlaceholder: 'Rechercher des éléments pour ce groupe',
              modifiers: 'Modificateurs attachés dans ce groupe',
              attachedModifiers: 'Modificateurs attachés',
              modifiersPlaceholder: 'Rechercher des modificateurs pour ce groupe',
              minRangeError: 'Doit être inférieur ou égal au maximum',
              infinteItems: 'aucune limite',
              maxRangeError: 'Doit être supérieur ou égal au minimum',
              surchargeLimit: 'Limite de surcharge',
              limitRangeError: 'Doit être supérieur ou égal au minimum et inférieur au maximum',
              limitLabel: '# de modificateurs avant application de la surcharge',
              limitTooltip:
                "Les invités seront facturés le prix 'avant surcharge' jusqu'à ce que ce montant soit atteint. Après, le prix de surcharge sera appliqué.",
              limitInfoSingular: 'surcharges appliquées après {total} sélection',
              limitInfoPlural: 'surcharges appliquées après {total} sélections',
              limitRequired: 'Doit avoir une limite',
              createSuccess: 'Groupe de modificateurs créé avec succès',
              updateSuccess: 'Groupe de modificateurs mis à jour avec succès',
              deleteSuccess: 'Groupe de modificateurs supprimé avec succès',
              modifierSearch: 'Trouver des modificateurs à attacher',
              itemsSearch: 'Trouver des éléments à attacher',
              menuActionLabel: 'Plus',
              noToggleSelectedError:
                "Soit la limite de surcharge soit l'incrémental doit être activé.",
              tabLabels: {
                general: 'Général',
                modifiers: 'Modificateurs',
                items: 'Éléments',
              },
              subHeaders: {
                advancedSettings: 'Paramètres avancés',
                geniusSettings: 'Paramètres Genius',
                altLanguagesSettings: 'Langues alternatives',
              },
              nextep: {
                tooltip: 'Vous pouvez mettre à jour les paramètres Genius sous Modificateurs',
                quantityAlert:
                  'Vous pouvez ajouter des prix avant et après surcharge sous {entity}',
                modifiers: 'Modificateurs',
                optionAlert: "Vous pouvez ajouter des prix d'option sous {entity}",
              },
              altLanguages: {
                nameLabel: 'Nom du groupe',
                namePlaceholder: 'Saisir un nom',
              },
              orderType: {
                selection: 'Commander par sélection',
                selectionSubText:
                  "Choisir parmi les options disponibles pour personnaliser l'élément.",
                quantity: 'Commander par quantité',
                quantitySubText: 'Spécifier les quantités pour chaque option.',
                option: 'Commander par option',
                optionSubText: 'Personnaliser les sélections avec des options comme moins ou plus.',
                confirmationHeader: 'Confirmation',
                confirmationInfo:
                  'Changer votre type de commande Genius affecte la façon dont les invités peuvent personnaliser leurs éléments. \n Êtes-vous sûr de vouloir changer {modifierGroupName} en {orderType} ?',
                accept: 'Oui, changer',
                cancel: 'Annuler',
              },
              optionSizing: {
                sizing: 'Option de taille Genius',
                sizingPlaceholder: 'Choisir le type',
                lessNormalMore: 'Moins, normal, plus',
                noneNormalExtra: 'Aucun, normal, extra',
                sideNormalExtra: 'Côté, normal, extra',
              },
              delete: {
                dialog: {
                  header: 'Confirmation de suppression',
                  message:
                    'Êtes-vous sûr de vouloir supprimer {RecordName} ?\n Cette action ne peut pas être annulée.',
                  acceptLabel: 'Oui, supprimer',
                  rejectLabel: 'Non, annuler',
                },
              },
            },
            itemRangeLabelInfo: {
              fixed: 'Choisir {number}',
              upTo: "Choisir jusqu'à {number}",
              atLeastUpTo: "Choisir au moins {min}, jusqu'à {max}",
              atLeast: 'Choisir au moins {number}',
              any: 'Choisir autant que vous voulez',
            },
            itemRangeValidation: {
              max: 'Vous ne pouvez pas choisir plus de {number} éléments pour ce groupe',
              atLeast: 'Choisissez au moins {number} éléments pour ce groupe',
            },
            groupAddMod: {
              addMod1: 'Attacher un modificateur',
              addMod2: 'Attacher un modificateur',
              create: 'Créer',
              createModifierButton: 'Créer un modificateur',
              addModSidebar: {
                title: 'Attacher un modificateur',
                info: "Rechercher et sélectionner un modificateur existant pour l'attacher à ce groupe.",
                searchLabel: 'Rechercher par nom',
                searchPlaceholder: 'Rechercher un modificateur par nom',
                selectedModifiers: 'Modificateurs sélectionnés',
                posid: 'POSID : ',
                recentResults: 'Modificateurs récemment ajoutés',
                results: 'Résultats : {number}',
                noResultsInfo: "Nous n'avons trouvé aucun modificateur contenant cette requête",
                selectState: 'Sélectionner',
                unselectState: 'Désélectionner',
                primaryAction: 'Attacher',
                secondaryAction: 'Annuler',
                menuActionLabel: 'Plus',
                noModifiers: 'Aucun modificateur disponible à ajouter',
              },
            },
          },
          table: {
            columns: {
              name: 'Nom',
              posid: 'POSID',
              active: 'Statut',
              inStock: 'En stock',
              price: 'Prix',
              basePrice: 'Prix de base',
              tags: 'Étiquettes pour le filtrage dans Centric OS',
              updatedAt: 'Mis à jour',
            },
            noModifiersLine1: "Ce groupe n'a pas de modificateurs",
            noModifiersLine2: 'Veuillez en ajouter pour utiliser ce groupe',
            tableEmpty: 'Rien ici pour le moment',
            tableLoading: 'Chargement des données des modificateurs. Veuillez patienter.',
            pageReport: "{'{first}'} - {'{last}'} sur {'{totalRecords}'} modificateurs",
            globalIndicatorAriaLabel: 'Indicateur de parent global pour {entity}',
            globalIndicatorAriaDescription:
              "Cette relation est héritée d'un parent global pour {entity}",
            globalIndicatorTooltip: "Cette relation est héritée d'un parent global",
            filters: {
              itemNamePlaceholder: 'Rechercher un modificateur par nom',
              posidPlaceholder: 'Rechercher par POSID',
              pricePlaceholder: 'Rechercher par prix',
              isActivePlaceholder: 'Tous les statuts',
              isInStockPlaceholder: 'Tous les statuts',
              updatedAtPlaceholder: 'Dernière mise à jour',
              tagsPlaceholder: 'Toutes les étiquettes',
              isActive: 'Actif',
              isNotActive: 'Inactif',
              isInStock: 'En stock',
              isNotStock: 'Pas en stock',
              tags: 'étiquette | étiquettes',
            },
            actionBar: {
              totalSelected: '{total} modificateurs sélectionnés',
              bulkUpdate: 'Mise à jour en lot',
            },
          },
        },
        items: {
          pageTitle: 'Éléments de menu local',
          containerWeightTooltip:
            "Le poids du contenant est le poids du contenant fourni avec l'élément alimentaire. Aussi connu sous le nom de poids de tare.",
          createSuccess: 'Élément créé avec succès',
          updateSuccess: 'Élément mis à jour avec succès',
          deleteSuccess: 'Élément supprimé avec succès',
          createItemButton: 'Créer un élément',
          attachCpgItemBtn: 'Attacher CPG',
          noModifiers: "Aucun groupe de modificateurs n'est attaché à cet élément",
          bulkSidebar: {
            updateItemTitle: "({number}) Mise à jour en lot de l'élément",
            multipleValues: '(Valeurs multiples)',
            multiple: '(Multiple)',
            reset: 'Réinitialiser',
            bulkReviewInfo:
              'Vous êtes sur le point de mettre à jour les valeurs de ces champs. Veuillez examiner et confirmer que ce sont les modifications que vous souhaitez apporter :',
            bulkDeleteReviewInfo:
              'Vous êtes sur le point de supprimer ces éléments. Veuillez examiner et confirmer que ce sont les modifications que vous souhaitez apporter :',
            items: 'Éléments :',
            itemsConfirmation: 'Ces modifications influenceront :',
            itemsToDeleteConfirmation: 'Cette action supprimera :',
            bulkConfirmationText: 'Êtes-vous sûr de vouloir appliquer vos modifications ?',
            bulkDeleteText: 'Êtes-vous sûr de vouloir supprimer ces éléments ?',
            bulkDeleteSuccess: 'Éléments supprimés avec succès',
            checkboxConfirmation:
              'Je comprends que ces modifications ne peuvent pas être annulées.',
            accept: 'Oui, appliquer',
            cancel: 'Non, annuler',
            noItemsModified: "Il n'y a pas de modifications aux éléments sélectionnés.",
            alertNoItemsAccept: 'Ok',
            updateSuccess: '{number} éléments mis à jour avec succès',
            saveChanges: 'Enregistrer les modifications ?',
            noModifiers:
              'Les éléments sélectionnés ({total}) ne partagent aucun groupe de modificateurs identique. Attachez un groupe à eux.',
          },
          bulkAttachToCategory: {
            buttonLabel: 'Attacher à une catégorie',
            title: 'Attacher les éléments à une catégorie',
            subHeader: 'Sélectionner la destination',
            menuLabel: 'Menu',
            menuPlaceholder: 'Sélectionner un menu',
            categoryLabel: 'Catégorie',
            categoryPlaceholder: 'Sélectionner une catégorie',
            primaryAction: 'Attacher',
            successToast: 'Éléments attachés à la catégorie avec succès',
          },
          bulkAttachToModifierGroup: {
            buttonLabel: "Attacher à un groupe de modificateurs",
            title: "Attacher les éléments à un groupe de modificateurs",
            subHeader: 'Sélectionner la destination',
            modifierGroupLabel: 'Groupe de modificateurs',
            modifierGroupPlaceholder: 'Sélectionner un groupe de modificateurs',
            primaryAction: 'Attacher',
            successToast: 'Éléments attachés au groupe de modificateurs avec succès',
          },
          sidebar: {
            tabLabels: {
              general: 'Général',
              modifierGroups: 'Groupes de modificateurs',
              menuWorks: 'Menuworks',
              aiTools: 'Outils IA',
              selectedItems: 'Éléments sélectionnés',
            },
            jwoTaxCodeLabel: 'Code fiscal JWO',
            jwoTaxCodePlaceholder: 'Sélectionner un code fiscal',
            active: 'Actif',
            inactive: 'Inactif',
            createItemTitle: 'Créer un nouvel élément',
            updateItemTitle: "Mettre à jour l'élément",
            updateItemTitleName: 'Mettre à jour {item}',
            duplicateMenuLabel: 'Dupliquer',
            duplicateItemTitle: 'Dupliquer {item}',
            duplicateItemBtn: "Dupliquer l'élément",
            fullView: 'Vue complète',
            status: 'Statut',
            featured: "Suggérer l'élément à la caisse",
            featuredTag: 'Suggéré à la caisse',
            inStock: 'En stock',
            uploadImageLabel: "Image de l'élément",
            name: "Nom de l'élément",
            namePlaceholder: 'Saisir un nom',
            label: "Nom dans l'application",
            labelPlaceholder: "Ajouter nouveau ou utiliser le nom par défaut de l'élément",
            priceManagement: {
              title: 'Gestion des prix',
              price: 'Prix',
              basePrice: 'Prix de base',
              pricePlaceholder: '$Mettre un prix',
              priceTooltip:
                'Le prix de base est le prix de départ pour cet élément. Les niveaux de prix sont ajoutés par-dessus.',
              priceCaptionPriceLevels:
                'Cet élément a {quantity} niveau de prix. Sélectionnez {fullView} pour le modifier. | Cet élément a {quantity} niveaux de prix. Sélectionnez {fullView} pour les modifier.',
              priceCaptionNoPriceLevels:
                "Cet élément n'a pas de niveaux de prix. Créez des niveaux de prix lorsque vous modifiez un groupe de menu",
              priceCaptionFullView: 'Vue complète',
            },
            mealValue: 'Valeur du repas',
            mealValuePlaceholder: 'Ajouter une valeur de repas',
            posid: 'POSID',
            posidPlaceholder: 'Le POSID sera auto-généré',
            barcode: 'Code-barres',
            barcodePlaceholder: 'Ajouter un code-barres',
            calories: 'Calories',
            caloriesPlaceholder: 'Ajouter des calories',
            containerWeight: 'Poids du contenant',
            weightAmount: 'Quantité de poids',
            weightAmountPlaceholder: 'Ajouter une valeur',
            weightUnit: 'Unité de poids',
            weightUnitPlaceholder: 'Sélectionner une unité',
            modifierGroupSearch: 'Trouver des groupes de modificateurs à attacher',
            modifierGroups: 'Groupes de modificateurs attachés',
            modifierGroupsPlaceholder: 'Rechercher des groupes de modificateurs pour cet élément',
            modifierGroupsEmptyState: 'Rien ici !',
            reportingCategory: 'Catégorie de rapport',
            reportingCategoryPlaceholder: 'Sélectionner une catégorie',
            reportingSubCategory: 'Sous-catégorie de rapport',
            reportingSubCategoryPlaceholder: 'Rechercher ou taper une sous-catégorie',
            reportingSubCategoryNoResults:
              'Aucun résultat pour ce critère. Cela créera une nouvelle sous-catégorie de rapport.',
            kitchenRoute: 'Route de cuisine',
            kitchenRoutePlaceholder: 'Sélectionner ou créer une route de cuisine',
            priority: 'Séquence dans KDS',
            priorityPlaceholder: 'Ajouter une séquence pour KDS',
            taxTags: 'Étiquettes fiscales',
            taxTagsPlaceholder: 'Aucune pour le moment',
            description: 'Description',
            generateDescription: 'Générer une description',
            generateDescriptionNoLabelError:
              "Entrez 'Nom dans l'application' pour activer la génération de description.",
            generateDescriptionEnabledTooltip:
              "Utilisez l'IA pour créer une description convaincante basée sur le 'Nom dans l'application' et les modificateurs d'élément. Notez que l'interprétation de l'IA peut varier avec des idées complexes ou abstraites.",
            generateImage: 'Générer une image',
            generateImageNoDescriptionError:
              "Entrez une description d'élément pour activer la génération d'image.",
            generateImageEnabledTooltip:
              "Utilisez l'IA pour générer une image basée sur la description de l'élément. Pour des résultats optimaux, saisissez une description détaillée et concise. Notez que l'interprétation de l'IA peut varier avec des idées complexes ou abstraites.",
            descriptionPlaceholder: 'Ajouter une description',
            primaryAction: 'Enregistrer',
            secondaryAction: 'Annuler',
            menuActionLabel: 'Plus',
            advancedSettingsTitle: 'Paramètres avancés',
            delete: {
              menuTabLabel: 'Supprimer',
              menuTabLabelBulk: 'Tout supprimer',
              dialog: {
                header: 'Confirmation de suppression',
                message:
                  'Êtes-vous sûr de vouloir supprimer {RecordName} ?\n Cette action ne peut pas être annulée.',
                acceptLabel: 'Oui, supprimer',
                rejectLabel: 'Non, annuler',
              },
            },
            itemRangeValidation: {
              max: "Vous ne pouvez pas choisir le groupe {name} car le maximum d'éléments est atteint",
            },
          },
          sequencingDialog: {
            header: 'Organiser les éléments',
            details:
              "Déplacez les éléments dans l'ordre dans lequel vous voulez qu'ils apparaissent dans les applications et kiosques.",
            cancel: 'Annuler',
            save: "Mettre à jour l'arrangement",
          },
          table: {
            title: 'Tous les éléments',
            actionBar: {
              totalSelected: '{total} éléments sélectionnés',
              bulkUpdate: 'Mise à jour en lot',
            },
            deleted: 'Supprimé',
            globalIndicatorTooltip: "Cette relation est héritée d'un parent global",
            globalIndicatorAriaLabel: 'Indicateur de parent global pour {entity}',
            globalIndicatorAriaDescription:
              "Cette relation est héritée d'un parent global pour {entity}",
            removeAttachmentTooltip: "Cela supprimera l'élément de cette catégorie",
            header: {
              nameGroupLabel: 'Nom (au moins 1 est requis)',
              optionalGroupLabel: 'Optionnel',
            },
            filters: {
              defaultNamePlaceholder: 'Rechercher un élément par nom',
              pricePlaceholder: 'Rechercher par prix',
              posidPlaceholder: 'Rechercher par POSID',
              barcodePlaceholder: 'Rechercher par code-barres',
              tagPlaceholder: 'Toutes les étiquettes',
              isActivePlaceholder: 'Tous les statuts',
              updatedAtPlaceholder: 'Dernière mise à jour',
              isInStockPlaceholder: 'Tous les statuts',
              isActive: 'Actif',
              isNotActive: 'Inactif',
              isInStock: 'En stock',
              isNotStock: 'Pas en stock',
              tags: 'étiquette | étiquettes',
            },
            columns: {
              items: 'Nom',
              inAppName: "Nom dans l'application",
              price: 'Prix',
              basePrice: 'Prix de base',
              posid: 'POSID',
              barcode: 'Code-barres',
              tags: 'Étiquettes pour le filtrage dans Centric OS',
              status: 'Statut',
              inStock: 'En stock',
              updatedAt: 'Mis à jour',
            },
            pageReport: "{'{first}'} - {'{last}'} sur {'{totalRecords}'} éléments",
            tableEmpty: 'Rien ici pour le moment',
            tableLoading: 'Chargement des données des éléments. Veuillez patienter.',
          },
          cpgSidebar: {
            headerTitle: 'Attacher des biens de consommation emballés',
            primaryAction: 'Attacher',
            searchInfo:
              "Recherchez et sélectionnez un bien de consommation emballé existant de ce groupe de menu local pour l'attacher à votre marque.",
            searchPlaceholder: "Rechercher par nom d'élément",
            searchLabel: 'Rechercher des éléments à ajouter',
            recentItems: 'Éléments récemment ajoutés',
            searchResults: '{total} élément(s) trouvé(s)',
            upc: 'UPC : {upc}',
            barcode: 'Code-barres : {barcode}',
            minimumItemSelect: 'Sélectionnez au moins un élément à attacher',
            selectedValues: 'Sélectionné ({total})',
            duplicateBarcodeText: 'Ce code-barres existe déjà dans cette marque',
            searchingItems: "Recherche d'éléments...",
            createSuccess: '{total} éléments attachés avec succès',
            selectState: 'Sélectionner',
            unselectState: 'Désélectionner',
            noItems: 'Aucun élément disponible à ajouter',
          },
        },
        generic: {
          altLanguages: {
            addCTA: 'Ajouter une option de langue',
            langOptionLabel: 'Option de langue',
            langOptionPlaceholder: 'Choisir une option de langue',
            deleteCTA: "Supprimer l'option de langue",
            optionLabels: {
              fr: 'Français',
              kvi: 'KVI',
              es: 'Espagnol',
            },
          },
          syncToGlobal: {
            syncCTA: 'Synchroniser les modifications',
            undoSyncCTA: 'Annuler la synchronisation',
          },
          statusChip: {
            label: "Rupture de stock aujourd'hui",
            tooltip: 'Marqué comme en rupture de stock dans KDS. Sera de nouveau actif demain.',
          },
          taxTagCode: {
            label: "Code d'étiquette fiscale",
            activeSwitchLabel: "Exonéré d'impôt",
            placeholder: "Ajouter un code d'étiquette fiscale",
            exemptValue: 'EXONÉRÉ',
          },
          tags: {
            label: 'Étiquettes pour le filtrage dans Centric OS',
            tagsPlaceholder: 'Sélectionner ou taper une nouvelle',
            tagsPlaceholderSelected: '{total} étiquette(s)',
          },
          multipleValues: '(Valeurs multiples)',
          kdsName: {
            label: 'Nom sur KDS',
            placeholder: 'Saisir le nom KDS',
          },
          posId: {
            label: 'POSID',
            notAvailable: 'Sera auto-généré',
            copyAriaLabel: 'Copier le POSID',
            copyToast: 'POSID copié dans le presse-papiers',
            copyErrorToast: 'Échec de la copie du POSID',
          },
          receipt: {
            receiptName: 'Nom sur le reçu',
            receiptText: 'Saisir le nom du reçu',
          },
          aiGeneration: {
            header: "GÉNÉRATEUR D'IMAGE IA",
            generate: 'Générer une image',
            banner: {
              inAppName: "Nom dans l'application",
              modifierGroups: 'Groupes de modificateurs',
              description: 'Description',
              text: "La description est générée avec l'IA en utilisant les détails {fieldName1} et {fieldName2}. Pour générer une image IA, les {fieldName1} et {fieldName3} sont requis. Notez que l'interprétation de l'IA peut varier avec des idées complexes ou abstraites",
            },
          },
          menuWorksCreate: {
            back: 'Retour',
            createEntity: 'Créer {entityType}',
            mrn: 'MRN',
            name: 'Nom {entityType}',
            label: "Nom dans l'application",
            nameOnKds: 'Nom sur KDS',
            nameOnReceipt: 'Nom sur le reçu',
            description: 'Description',
            ingredients: 'Ingrédients',
            smartTags: 'Étiquettes intelligentes',
            allergens: "Étiquettes d'allergènes",
            calories: 'Calories',
            cals: '{value} Cal',
            weight: 'Quantité de poids',
            cost: 'Coût par portion',
            gross: 'Bénéfice brut',
            grossPlaceholder: '(Aucun)',
            margin: 'Marge',
            price: 'Prix',
            basePrice: 'Prix de base',
            marginPlaceholder: '- %',
            primaryAction: 'Créer {entityType}',
            cancelAction: 'Retour',
          },
        },
        menuWorks: {
          syncHeaderTitle: 'Synchroniser les informations Menuworks',
          syncInfo:
            "Vous pouvez synchroniser les informations MenuWorks avec votre élément. Entrez votre MRN (Numéro de référence maître). Cela n'écrasera aucun de votre travail.",
          attributesTitle: "Attributs de l'élément",
          mrn: 'MRN',
          mrnPlaceholder: '1234567890',
          syncData: 'Synchroniser les données',
          portionQuantity: 'Quantité de portion',
          portionQuantityPlaceholder: 'Ajouter une valeur',
          unitOfMeasurement: 'Unité de mesure',
          unitOfMeasurementPlaceholder: 'Sélectionner une unité',
          calories: 'Calories',
          caloriesPlaceholder: 'Ajouter des calories',
          cost: 'Coût par portion',
          costPlaceholder: 'Aucun pour le moment',
          syncError: "Cela n'a pas synchronisé. Vérifiez vos informations et réessayez.",
          overwriteLabel: 'Écraser les valeurs actuelles',
          menuWorksValues:
            'Les données suivantes seront écrasées : \n Nom \n Calories \n Poids \n Description \n Quantité de portion \n Unité de mesure \n Ingrédients \n Allergènes \n Étiquettes intelligentes',
          createDialog: {
            title: 'Créer {entityType}',
            inputLabel: 'Produit MenuWorks',
            inputLabelMrnOnly: 'Numéro de recette MenuWorks (MRN)',
            inputPlaceholder: 'Exemple : 34567 ou Soupe de poulet aux nouilles',
            inputPlaceholderMrnOnly: 'Entrez le MRN (exemple : 12345 ou 123.45)',
            inputDescription:
              'La synchronisation récupère les ingrédients, le coût, la nutrition et plus encore',
            inputDescriptionMrnOnly:
              "L'utilisation d'un MRN fait gagner du temps en synchronisant les ingrédients de l'article, le coût et plus encore",
            getMrnInfoBtnLabel: 'Obtenir les infos MRN',
            useMrnBtnLabel: 'Utiliser le MRN',
            useThisMrnBtnLabel: 'Utiliser ce MRN',
            goBackBtnLabel: 'Retour',
            searchBtnAriaLabel: 'Rechercher des produits MenuWorks',
            suggestedHeader: 'Suggestions MenuWorks',
            suggestionDescription:
              'Sélectionnez votre produit MRN dans cette liste ou recherchez-en un nouveau',
            searchInsteadBtnLabel: 'Rechercher un nouveau produit',
            manualItemCreateBtnLabel: 'Créer {entityType} manuellement',
            invalidMRN: "Vérifiez le MRN et réessayez. Nous n'avons pas pu trouver ce numéro",
            menuworksDown: 'Menuworks est temporairement indisponible',
            loadingText: 'Synchronisation des informations MenuWorks...',
          },
          createSuccessDialog: {
            title: '{entityType} Créé !',
            createAgainBtn: 'Créer un autre {entityType}',
            goToItemBtn: 'Aller à {entityType}',
            mainText: ' est maintenant dans les {entityType}s de votre marque',
          },
        },
        activityLog: {
          table: {
            title: "Journal d'activité",
            tableEmpty: 'Aucune activité pour le moment',
            pageReport: "{'{first}'} - {'{last}'} sur {'{totalRecords}'} événements",
            columns: {
              dateTime: 'Horodatage',
              description: "Description de l'activité",
              details: "Détails de l'activité",
              detailsCTA: 'Afficher les détails',
            },
            filters: {
              keywordPlaceholder: "Rechercher la description de l'activité",
              usernamePlaceholder: 'Tous les utilisateurs',
              statusTypePlaceholder: 'Toutes les activités',
            },
            statusTypes: {
              updates: 'Mises à jour',
              create: 'Créer',
              delete: 'Supprimer',
              publish: 'Publier',
              globalUpdates: 'Mises à jour globales',
              syncChannel: 'Canal de synchronisation',
              import: 'Importer',
              scheduling: 'Planification',
            },
            activityDescription: {
              entityDeletedWarning: '{deletedBy} a ensuite supprimé le {entityType} {date}', // pour aujourd'hui et hier
              entityDeletedWarningOn: '{deletedBy} a ensuite supprimé le {entityType} le {date}', // pour les autres jours
            },
          },
          errorSidebar: {
            title: "Détails de l'activité",
            processId: 'ID de processus',
            processIdCopyAriaLabel: "Copier l'ID de processus",
            processIdCopyToast: 'ID de processus copié dans le presse-papiers',
            processIdCopyErrorToast: "Échec de la copie de l'ID de processus",
            infoLabel: 'Informations de dépannage',
            infoBlurb:
              "Vous pouvez copier ces informations dans un ticket avec l'équipe de soins numériques pour aider à résoudre le problème.",
            infoCopyCTA: 'Copier les informations',
            activitiesLabel: 'Activités liées',
            infoCopyToast: 'Informations de dépannage copiées dans le presse-papiers',
            infoCopyErrorToast: 'Échec de la copie des informations de dépannage',
          },
          globalChangesSidebar: {
            title: 'Mises à jour de menu global',
          },
          menuWorksImportSidebar: {
            title: "Détails de l'importation",
            unitLabel: 'Unité MenuWorks',
            menuLabel: 'Menu MenuWorks',
            dayPartLabel: 'Partie de journée',
            itemGroupsLabel: 'Groupe d’articles',
            informationUnavailable: 'Information indisponible',
            errorsLabel: 'Erreurs d\'importation',
            error500Message: 'MenuWorks n\'a pas pu importer vos données de menu',
            errorGenericMessage: 'L\'importation n\'a pas pu être complétée',
            partialImportErrorCopyCTA: 'Copier les informations',
            partialImportErrorsCopySuccessToast:
              "Échecs d'importation partielles copiés dans le presse-papiers",
            partialImportErrorsCopyErrorToast:
              "Échec de la copie des échecs d'importation partielles",
          },
        },
      },
    },
    entityManagement: {
      localGroupBreadcrumb: 'Groupes de menu local',
      globalGroupBreadcrumb: 'Groupes de menu global',
      createEntityHeader: 'Créer un nouveau {entityType}',
      actionLabel: 'Enregistrer',
      cancelLabel: 'Annuler',
      actionSuccessToast: "{entityType} '{entityName}' enregistré avec succès",
      validationFailed:
        'Il y a eu une erreur avec le formulaire. Veuillez vérifier les champs et réessayer.',
      entities: {
        item: 'Élément',
        modifier: 'Modificateur',
        modifierGroup: 'Groupe de modificateurs',
        category: 'Catégorie',
        menu: 'Menu',
      },
      menuWorks: {
        connected: 'Connecté au MRN {mrn}',
        connectedWithParent:
          "Connecté au MRN {mrn}. Cet élément ou modificateur provient d'un menu global. Il ne peut pas être déconnecté.",
        disconnected: 'Non connecté au MRN',
        disconnectedWithParent:
          "Non connecté au MRN. Cet élément ou modificateur provient d'un menu global. Pour connecter un MRN, dupliquez-le vers votre menu local.",
        connectAction: 'Connecter',
        disconnectAction: 'Déconnecter MRN',
        resyncAction: 'Vérifier les mises à jour',
        syncWithMenuWorksAction: 'Synchroniser avec MenuWorks',
        connectedNotSyncedMain:
          'Connecté au MRN {mrn}. Synchronisez pour recevoir les mises à jour MenuWorks',
        connectedNotSyncedWithParentMain:
          "Connecté au MRN {mrn}. Cet élément ou modificateur provient d'un menu global. Synchronisez pour recevoir les mises à jour MenuWorks",
        lastSyncNone: 'Dernière synchronisation MenuWorks : Aucune.',
        lastSyncAt: 'Dernière synchronisation MenuWorks : {date}.',
        syncInfo:
          "Se connecter à MenuWorks avec un numéro de recette MenuWorks (MRN) vous donne accès aux mises à jour d'éléments",
        syncSuccess: 'Élément mis à jour avec succès',
        noUpdatesFound: 'Aucune mise à jour trouvée',
        nutritionValuesUpdated: 'Valeurs nutritionnelles mises à jour',
        iconsValuesUpdated: 'Les icônes MenuWorks ont été mises à jour sur votre formulaire.',
        syncDialog: {
          connectHeader: 'Se connecter au MRN',
          connectLoadingHeader: 'Obtention des informations MRN...',
          resyncLoadingHeader: 'Vérification des mises à jour MRN...',
        },
        syncDetails: {
          connectHeader: 'Se connecter au MRN',
          resyncHeader: 'Mises à jour MRN',
          connectPrimaryActionLabel: 'Se connecter au MRN',
          resyncPrimaryActionLabel: 'Mettre à jour { entityType }',
          connectWarning:
            "Les mises à jour MenuWorks remplaceront les détails de l'élément mais n'écraseront pas les modificateurs ou les ajouts qui ne s'affichent pas ici.",
          connectItemModifierWarning:
            "Les mises à jour MenuWorks remplacent les détails de l'élément ou du modificateur, mais ne changeront pas les prix, les ajouts ou d'autres attributs locaux que vous pouvez modifier.",
          resyncWarning:
            'Les mises à jour MenuWorks ajouteront ou remplaceront uniquement les détails {entityType} affichés.',
        },
        confirmDialog: {
          header: 'Continuer à déconnecter MRN ?',
          message:
            'Vos paramètres Genius seront réinitialisés par défaut. Si vous décidez de vous reconnecter plus tard, vous devrez les configurer à nouveau. Ce changement ne peut pas être annulé.',
          acceptLabel: 'Continuer',
          rejectLabel: 'Annuler',
        },
        syncInProgressLabel: 'Synchronisation avec MenuWorks en cours',
        syncInProgressInfo:
          "Ne modifiez pas les numéros de recette MenuWorks tant qu'une synchronisation de marque est en cours.",
      },
      panels: {
        entityType: '{entity}',
        names: 'Noms {entity}',
        pricing: 'Tarification',
        priceManagement: 'Gestion des prix',
        priceLevels: 'Niveaux de prix',
        reporting: 'Rapport',
        display: 'Affichage {entity}',
        modifierGroups: 'Modificateurs',
        tags: 'Étiquettes',
        setup: 'Configuration {entity}',
        altLanguages: 'Langues alternatives',
        dangerous: 'Zone dangereuse',
        dangerousInfo: 'Ceci est une zone dangereuse. Soyez prudent avec vos actions.',
        requiredField: '* 1 champ requis',
        requiredFields: '* {total} champs requis',
      },
      fields: {
        nameLabel: 'Nom',
        namePlaceholder: 'Saisir un nom par défaut',
        imageLabel: 'Image',
        descriptionLabel: 'Description sur le menu',
        descriptionHelperText: '1-2 phrases, gardez-le facile à lire (200 caractères)',
        descriptionCounterText: 'Nombre de caractères: {currentCharCount}',
        descriptionPlaceholder: 'Ajouter une description',
        inAppNameLabel: "Nom dans l'application",
        inAppNamePlaceholder: "Saisir un nom dans l'application",
        kdsLabel: 'Nom sur KDS',
        kdsPlaceholder: 'Saisir un nom à utiliser sur KDS',
        receiptLabel: 'Nom sur le reçu',
        receiptPlaceholder: 'Saisir un nom à afficher sur le reçu',
        usingDefaultNamePlaceholder: 'Utilisation du nom par défaut : {name}',
        usingInAppNamePlaceholder: "Utilisation du nom dans l'application : {name}",
        priceLabel: 'Prix',
        basePriceLabel: 'Prix de base',
        pricePlaceholder: '$Mettre un prix',
        geniusPriceLabel: 'Prix Genius {fieldName}',
        preSurcharge: 'Pré-surcharge',
        preSurchargePlaceholder: '$Mettre un prix',
        posLabel: 'Nom sur POS',
        posPlaceholder: 'Saisir un nom à utiliser sur POS',
        postSurcharge: 'Post-surcharge',
        postSurchargePlaceholder: '$Mettre un prix',
        priceForNone: 'Prix pour aucun',
        priceForLess: 'Prix pour moins',
        priceForSide: 'Prix pour côté',
        priceForMore: 'Prix pour plus',
        priceForExtra: 'Prix pour extra',
        preSurchargeTooltip:
          "Ajouter un prix personnalisé à ce modificateur qui est appliqué jusqu'à ce que la limite de surcharge soit atteinte. Prix normal par défaut.",
        postSurchargeTooltip:
          'Ajouter un prix personnalisé à ce modificateur qui est appliqué après que la limite de surcharge soit atteinte. Prix normal par défaut.',
        costLabel: 'Coût',
        marginLabel: 'Marge',
        geniusMarginLabel: 'Marge Genius {fieldName}',
        notAvailable: '-',
        mealValueLabel: 'Valeur du repas',
        mealValuePlaceholder: 'Ajouter une valeur de repas',
        taxTagsLabel: 'Étiquettes fiscales',
        taxTagsPlaceholder: 'Sélectionner une étiquette fiscale',
        reportingPrimary: 'Catégorie de rapport',
        reportingSecondary: 'Sous-catégorie de rapport',
        reportingPlaceholder: 'Sélectionner une catégorie',
        reportingSecondaryPlaceholder: 'Rechercher ou taper une sous-catégorie',
        reportingEmpty:
          'Aucun résultat pour ce critère. Cela créera une nouvelle sous-catégorie de rapport.',
        jdeLabel: 'Catégorie JDE (sites canadiens uniquement)',
        jdePlaceholder: 'Choisir une catégorie JDE',
        caloriesLabel: 'Calories',
        caloriesPlaceholder: 'Ajouter des calories',
        weightAmountLabel: 'Poids du contenant',
        weightAmountPlaceholder: 'Ajouter une valeur',
        weightTooltip:
          "Le poids du contenant est le poids du contenant fourni avec l'élément alimentaire. Aussi connu sous le nom de poids de tare.",
        weightUnitLabel: 'Unité de poids',
        weightUnitPlaceholder: 'Sélectionner une unité',
        findToAttach: 'Trouver {entityToAttach}s à attacher',
        findToAttachPlaceholder: 'Rechercher {entityToAttach}s pour ce {entityType}',
        attachLabel: '{entityToAttach}s attachés au {entityType}',
        attachPlaceholder: "Aucun {entityToAttach}s n'est attaché à ce {entityType}",
        globalIndicatorAriaLabel: 'Indicateur de parent global pour {entity}',
        globalIndicatorAriaDescription:
          "Cette relation est héritée d'un parent global pour {entity}",
        globalIndicatorTooltip: "Cette relation est héritée d'un parent global",
        ingredientsLabel: 'Ingrédients',
        smartTagsLabel: 'Étiquettes intelligentes',
        allergensLabel: "Étiquettes d'allergènes",
        barcodeLabel: 'Code-barres',
        barcodePlaceholder: 'Ajouter un code-barres',
        posidLabel: 'POSID',
        posidPlaceholder: 'Le POSID sera auto-généré',
        kitchenRouteLabel: 'Route de cuisine',
        kitchenRoutePlaceholder: 'Sélectionner ou créer une route de cuisine',
        isFeaturedLabel: "Suggérer l'élément à la caisse",
        filteringTagsLabel: 'Étiquettes pour le filtrage dans Centric OS',
        filteringTagsPlaceholder: 'Sélectionner ou taper une nouvelle',
        featuredTag: 'Suggéré à la caisse',
        taxTagCode: "Code d'étiquette fiscale",
        taxTagCodePlaceholder: "Ajouter un code d'étiquette fiscale",
        taxTagJwo: 'Code fiscal JWO',
        taxTagJwoPlaceholder: 'Sélectionner un code fiscal',
        taxExempt: "Exonéré d'impôt",
        priceLevelGlobalInfo:
          'Les niveaux de prix vous aident à regrouper les éléments en niveaux de tarification. Enregistrez et publiez pour refléter les changements sur les groupes de menu locaux',
        priceLevelLocalInfo:
          'Les niveaux de prix vous aident à regrouper les éléments en niveaux de tarification. Pour gérer les niveaux de prix localement, allez aux paramètres du groupe de menu local',
        priceLevelEmptyInfo:
          'Les niveaux de prix vous aident à regrouper les éléments en niveaux de tarification. Pour gérer les niveaux de prix localement, allez aux paramètres du groupe de menu {localOrGlobal}',
        altLangNameLabel: 'Nom {entityType}',
        altLangNamePlaceholder: 'Saisir un nom',
        altLangDescriptionLabel: 'Description {entityType}',
        altLangDescriptionPlaceholder: 'Ajouter une description',
      },
      delete: {
        deleteAction: 'Supprimer {entityType}',
        confirmHeader: 'Supprimer {entityName} ?',
        confirmMessage:
          'Cela effacera définitivement le {entityType} : {entityName}. Cela ne peut pas être annulé.',
        confirmAcceptLabel: 'Supprimer',
        confirmRejectLabel: 'Annuler',
        deleteSuccessToast: '{entityType} supprimé avec succès',
      },
    },
    menuWorksImport: {
      importButton: 'Importer des éléments',
      importButtonWithCount: 'Importer {count} éléments',
      importDialog: {
        title: 'Importer des produits MenuWorks',
        priceLabel: 'Prix',
        typeLabel: 'Type',
        confirmButton: "Confirmer l'importation",
        cancelButton: 'Annuler',
      },
      unitIdLabel: 'Unité MenuWorks',
      unitIdPlaceholder: 'Unité MenuWorks',
      table: {
        title: 'Navigateur de produits MenuWorks',
        maxSelectionReached:
          'Vous ne pouvez sélectionner que 10 éléments à la fois. Désélectionnez des éléments pour en ajouter plus.',
        actionBar: {
          totalSelected: '{total} éléments sélectionnés',
          importAction: 'Importer',
        },
        searchLabel: 'Rechercher par MRN ou nom',
        searchPlaceholder: 'Exemple : 43092, Burger',
        pageReport: "{'{first}'} - {'{last}'} sur {'{totalRecords}'} produits",
        tableEmpty: 'Aucun produit MenuWorks trouvé',
        columns: {
          MRN: 'MRN',
          name: 'Nom',
          productType: 'Type de produit',
          shortName: 'Nom court',
        },
      },
      importSuccess: 'Produits importés avec succès',
      syncStatus: {
        loading: 'Chargement du statut de synchronisation...',
        refreshingCache: 'Actualisation du cache des produits MenuWorks : {count}/{total}',
        lastSuccess: 'Dernière actualisation du cache des produits MenuWorks : {date}',
        failed:
          'Échec de la synchronisation. Dernière actualisation du cache des produits MenuWorks : {date}',
        justNow: "À l'instant",
        today: "Aujourd'hui",
        triggerRefresh: 'Déclencher l’actualisation',
      },
    },
    exportImport: {
      brand: {
        OR: 'OU',
        exportBtn: 'Exporter la marque',
        importBtn: 'Importer la marque',
        exportImportHeader: 'Exporter/Importer la marque',
        errorConfirm: 'Compris',
        cancel: 'Annuler',
        exportSuccess: 'Marque exportée',
        importFileUploaded: "Fichier téléchargé. L'importation prendra quelques instants.",
        exportFailed: 'Exportation échouée',
        importFailed: 'Importation échouée',
        importFailedWithValidation:
          "La validation du fichier d'importation a échoué. Voir le fichier Excel de validation pour les détails.",
        errorDialog: {
          header: 'Essayez cela à nouveau.',
          exportError: 'Il y a eu un problème. Réessayez.',
          tryAgain: 'Réessayer',
          cancel: 'Annuler',
        },
        catalogVersionLabel: 'Exporter depuis la version de sauvegarde',
        catalogVersionPlaceholder: 'Dernière version (par défaut)',
        catalogVersionListAriaLabel: 'Liste des versions de sauvegarde',
        catalogVersionInfo:
          "Une nouvelle version de sauvegarde est créée à chaque fois que la marque est publiée.\nSélectionnez une version pour exporter la marque telle qu'elle était à ce moment-là.",
      },
      menu: {
        ariaLabel: 'Actions Importer/Exporter',
        exportBrandLabel: 'Importer/Exporter la marque',
        menuWorksImportLabel: 'Importer depuis MenuWorks',
      },
      menuWorks: {
        title: 'Importer depuis MenuWorks',
        subtitle: 'Importer des menus depuis les unités MenuWorks connectées',
        importAction: 'Importer',
        unitField: {
          label: 'Numéro d’unité MenuWorks',
          placeholder: 'Sélectionner une unité MenuWorks',
        },
        menuField: {
          label: 'Menu MenuWorks',
          placeholder: 'Sélectionner un menu MenuWorks',
        },
        mealPeriodField: {
          label: 'Partie de journée',
          placeholder: 'Sélectionner une partie de journée depuis un menu MenuWorks',
        },
        noUnit: {
          title: 'Aucune unité MenuWorks disponible',
          bodyLocal:
            'L’importation d’articles MenuWorks nécessite une unité MenuWorks connectée. Connectez-en une depuis les paramètres du groupe de menu local.',
          bodyGlobal:
            'L’importation d’articles MenuWorks nécessite une unité MenuWorks connectée. Connectez-en une depuis les paramètres du groupe de menu global.',
          cancel: 'Annuler',
          connect: 'Connecter maintenant',
          illustrationAlt: 'Illustration aucune unité MenuWorks',
        },
        itemGroupField: {
          label: 'Groupe d’articles',
          placeholder: "Sélectionner un groupe d'éléments à importer",
        },
        noItemGroupWarning:
          'Aucun groupe d’articles n’est disponible pour cette unité sélectionnée. Choisissez-en une autre pour continuer',
        importStarted:
          'Importation MenuWorks démarrée. Les articles apparaîtront une fois l’importation terminée.',
        importSkipped:
          'Une importation ou une synchronisation MenuWorks est déjà en cours pour cette marque. Veuillez réessayer plus tard.',
      },
    },
  },
};
